import { type ExclusionAreaFeature } from './exclusionAreaTypeResolution'

export const withGrazingManagement = (
  exclusionAreas: ExclusionAreaFeature[] | null | undefined,
  featureId: string,
  newHasGrazingManagement: boolean,
): ExclusionAreaFeature[] =>
  (exclusionAreas || []).map(exclusionArea =>
    exclusionArea.properties.id === featureId
      ? {
          ...exclusionArea,
          properties: {
            ...exclusionArea.properties,
            hasGrazingManagement: newHasGrazingManagement,
          },
        }
      : exclusionArea,
  )
